module.exports = __webpack_public_path__ + "img/usman-yousaf-yIOViGQmjJ4-unsplash.88b26406.jpg";